import React from 'react';
import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Style = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;

  .legend {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    -webkit-touch-callout: none; 
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; 
    transition: .4s opacity;

    &.disabled {
      opacity: 0.5;
    }

    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        margin-bottom: 0px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
      }

      .circle {
        width: 8px;
        height: 8px;
        border-radius: 100%;
      }
    }
  }

  &.centered-legend {
    gap: 18px;
    
    .legend {
      flex: unset;
    }
  }
  
  &.risk-materialisation {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;

    .legend {
      flex: unset;
      width: fit-content;
    }
  }

  .grouped {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .group {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 15px;
      justify-content: center;

      p {
        white-space: nowrap;
      }

      .legend {
        flex: unset;
        justify-content: flex-start;
      }
    }
  }
`;

const Legend = ({
  legend = [],
  toggle = () => { },
  className = '',
  groupBy = false,
}) => {
  const renderLegend = () => {
    const render = (l) => (
      <div
        className={formatClassname(["legend", !l.toggled && 'disabled'])}
        key={`legend-${l.key}`}
        onClick={() => toggle(l)}
      >
        <div className="cont">
          <div className="circle" style={{ background: l.color }} />
        </div>
        <div className="cont">
          <p>{l.label}</p>
        </div>
      </div>
    );

    if (groupBy) {
      const pages = Math.round(legend.length / groupBy);
      const splitted = [];
      for (let i = 0; i <= pages - 1; i++) {
        splitted.push(legend.slice(i * groupBy, (i + 1) * groupBy));
      }

      return (
        <div className="grouped">
          {splitted.map((s, i) => (
            <div className="group" key={`splitted-grouped-${groupBy}-${i + 1}`}>
              {s.map((s) => render(s))}
            </div>
          ))}

        </div>
      );
    }
    return legend.map((l) => render(l));
  };

  return (
    <Style className={className}>
      {renderLegend()}
    </Style>
  );
}

export default Legend;
